<template>
  <v-container fluid>
    <intro-image/>
    <section class="content" v-html="page.tekst_2"/>
  </v-container>
</template>

<script>
import page from '~/plugins/mixins/page';
import IntroImage from '~/components/IntroImage';

export default {
  components: {
    IntroImage,
  },
  mixins: [page],
  data() {
    return {
      isActive: false,
    };
  },
};
</script>

<style lang="sass" scoped>
.content
  ::v-deep .row
    .col-12
      display: flex
      flex-direction: column
      justify-content: center
      padding: 0
      align-self: stretch

      figure
        height: 100%
        position: relative
        img
          height: 100%
          width: 100%
          object-fit: cover
          position: relative
          z-index: 2

    p, h2, h3
      padding: 0 12px
      @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
        padding: 0

    &:nth-of-type(1)
      figure
        &::before
          content: ''
          position: absolute
          top: -7%
          bottom: 0
          left: 0
          right: 7%
          background: var(--v-primary-lighten1)
          z-index: 1

    &:nth-of-type(2)
      position: relative
      z-index: 3

      .col-12
        margin: 6px 0

      @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
        transform: translateY(-20%)

        .col-12
          padding: 12px
          margin-bottom: 50px

    &:nth-of-type(3)
      .col-12
        &:nth-of-type(1)
          order: 2
        &:nth-of-type(2)
          order: 3
        &:nth-of-type(3)
          order: 4
          @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
            order: 3
        &:nth-of-type(4)
          order: 1
          margin-top: 60px
          @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
            order: 4
            margin-top: 0

      figure
        &::before
          content: ''
          position: absolute
          top: -6%
          bottom: 0
          left: 7%
          right: 0
          background: var(--v-primary-base)
          z-index: 1

    &:nth-of-type(4)

      figure
        &::before
          content: ''
          position: absolute
          top: -7%
          bottom: 0
          left: -7%
          right: 7%
          background: var(--v-primary-lighten1)
          z-index: 1
</style>
